import { render } from "./TabInvoice.vue?vue&type=template&id=462d26cf"
import script from "./TabInvoice.vue?vue&type=script&lang=js"
export * from "./TabInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__